import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    whatILike: en,
  },
  fr: {
    whatILike: fr,
  },
};
